import React from "react";

const Pages_About = () => {
  return <div>Pages_About</div>;
};

export default Pages_About;
